import type { InputsWarnings } from '@/components/organisms/DynamicForm/DynamicForm';
import { createContext } from 'react';

export type WarningsContext = {
  warnings?: InputsWarnings;
};

export const warningsContext = createContext({} as WarningsContext);

export const { Provider } = warningsContext;
